export type IconSize = "xxxs" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";

export const IconSizeTable: Record<IconSize, number> = {
  xxxs: 10,
  xxs: 12,
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
  xxl: 64,
  xxxl: 128
};

export const IconDefaultSize: IconSize = "md";
